import ReactPaginate from 'react-paginate';
import './Paginador.css'
import PropTypes from 'prop-types';

function Paginador({ page, setPage, itemsPerPage, totalItems }) {

    const pageCount = Math.ceil(totalItems / itemsPerPage);
    const handlePageClick = (event) => {
        setPage(event.selected)
    };

    return (
        <div>
            <ReactPaginate
                breakLabel="..."
                nextLabel="Próximo"
                onPageChange={handlePageClick}
                containerClassName="paginador-ntm"
                activeClassName="active"
                forcePage={page}
                pageRangeDisplayed={3}
                pageCount={pageCount}
                previousLabel="Anterior"
                renderOnZeroPageCount={null}
            />
        </div>
    );
}

export default Paginador;

Paginador.propTypes = {
    page: PropTypes.number.isRequired,
    setPage: PropTypes.func.isRequired,
    itemsPerPage: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
};